import { render, staticRenderFns } from "./deltree-pop.vue?vue&type=template&id=1b987dff&"
import script from "./deltree-pop.vue?vue&type=script&lang=js&"
export * from "./deltree-pop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/builds/MWmsPKDH/0/framework/qmai-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b987dff')) {
      api.createRecord('1b987dff', component.options)
    } else {
      api.reload('1b987dff', component.options)
    }
    module.hot.accept("./deltree-pop.vue?vue&type=template&id=1b987dff&", function () {
      api.rerender('1b987dff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/qm-picture-library/src/components/deltree-pop.vue"
export default component.exports